<template>
  <div class="product-list-card-wrapper" :bd-thc="item.thc_cbd_levels ? item.thc_cbd_levels.thc_level : ''" :bd-cbd="item.thc_cbd_levels ? item.thc_cbd_levels.cbd_level : ''" :bd-brand="(item.brand && item.brand.name ? item.brand.name : '')" :bd-plant-type="(item.cannabis_attributes && item.cannabis_attributes.plant_type) ?  item.cannabis_attributes.plant_type : ''">
    <div class="product-list-card-main weed-card pointer" @click.prevent="callback(item)">
      
      <div class="product-list-card-content">
        <div class="mb10">
          <h4 class="has-text-weight-semibold has-text-dark max-2-line">{{ getSixtyCharacters(item.name) }}</h4>
          <p v-if="item.brand && item.brand.name && (item.brand.name != 'No Brand')" class="is-size-11 has-text-weight-semibold letter-space-1">
            <span class="is-capitalized has-text-dark">{{ item.brand.name }}</span>
            <span v-if="item.cannabis_attributes && item.cannabis_attributes.plant_type" class="is-hidden-1104-min text-primary"><span class="has-text-dark" v-if="item.brand && item.brand.name && (item.brand.name != 'No Brand')"> |</span> {{ item.cannabis_attributes.plant_type }}</span>
          </p>
        </div>
        <p class="is-size-14 is-hidden-1103-max text-primary has-text-weight-semibold letter-space-1 is-capitalized">{{ (item.cannabis_attributes && item.cannabis_attributes.plant_type) ?  item.cannabis_attributes.plant_type : ''}}</p>
      </div>

      <div class="product-list-card-image-attrs">
        <div class="product-list-card-image pointer" @click.prevent="callback(item)">
          <img v-if="item.image" :src="item.image+'?d=200x200'" :alt="item.name" />
          <img v-else src="@/assets/img/leaf.png" :alt="item.name" />
        </div>
        <div :class="'product-list-card-attributes'+ (item.aromas && item.aromas.length > 0 ? ' has-aromas' : '')">
          <div v-if="thc || cbd" :class="'weed-thc-level body-text-dark ' + (item.category.thc_cbd_value_type)">
            <div class="thc" v-if="thc">
              <p class="is-size-12px">THC</p>
              <p class="is-size-12px has-text-weight-semibold">{{ thc }}</p>
              <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.thc_level : '')"><span></span><span></span><span></span></div>
            </div>
            <div class="cbd" v-if="cbd">
              <p class="is-size-12px">CBD</p>
              <p class="is-size-12px has-text-weight-semibold">{{ cbd }}</p>
              <div :class="'weed-thc-indicator ' + (item.thc_cbd_levels ? item.thc_cbd_levels.cbd_level : '')"><span></span><span></span><span></span></div>
            </div>
          </div>
          <div v-if="item.aromas && item.aromas.length > 0" :class="'aromas ' + (item.category.thc_cbd_value_type)">
            <p class="is-size-12px has-text-dark">Aromas</p>
            <ul v-html="aromasData(item.aromas)">
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div :class="'product-list-card-variants '+ (variants.length == 1 ? 'single': '')">
      <ul v-if="variants.length > 0">
        
        <li v-bind:key="variant.id+ '_list_type'"  v-for="variant in variants">
          <div class="variant out-of-stock" v-if="(variant.available == false) || (variant.no_of_units <= variant.inventory_threshold)">
            <span class="size letter-space-1">{{ variant.size }}</span>
            <span class="price has-text-weight-semibold letter-space-1">${{ variantPrice(variant) }}</span>
          </div>
          <div class="variant is-on-sale" v-else-if="isOnSale(variant)" @click.prevent="addToCart(variant)">
            <span class="size has-text-dark">{{ getThreeChars(variant.size) }}</span>
            <span class="price has-text-dark has-text-weight-semibold">${{ variantPrice(variant) }}</span>
            <p class="sale-tag">{{ saleItemPercentage(variant) }}</p>
          </div>
         
          <div class="variant bg-secondary" @click.prevent="addToCart(variant)" v-else>
            <span class="size letter-space-1">{{ variant.size }}</span>
            <span class="price has-text-weight-semibold letter-space-1">${{ variantPrice(variant) }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import Helpers from '@/Components/Helpers/Helpers';
import SelectVariant from "@/Components/Pages/Helpers/SelectVariant.vue";
import Env from "@/env";
import CartApis from '@/Components/Controllers/CartApis';
import VboutApis from '@/Components/Controllers/VboutApis';
import ProductApis from '@/Components/Controllers/ProductApis';
import { mapGetters, mapActions} from 'vuex';

export default {
  components: {
    SelectVariant
  },
  data() {
    return {
      productDetail: {},
      itemOnSale: false,
      itemOnSalePercentage: false,
     // totalNumberOfAddableVariants: 0,
      selectedVariant:{
      },
      cardImageHeight: 0,
      qty: 1,
    };
  },
  props: {
    item: Object,
    callback: {
      type: Function,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      vg_cartId: 'cart/id',
      vg_cartItems: "cart/cartItems",
      vg_cartItemsIds: "cart/cartItemsIds",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_selectedStore: "location/selected",
      vg_weightOnCart: "cart/cartWeight",
      vg_favProducts: "favouriteproducts/list",
      vg_guestLandedQueries: "location/guestLandedQueries",
    }),

    aromasIcon() {
      return Env.aromasIcon;
    },

    variants() {
      // First create unique variant , only for cannabis
      return  Helpers.getUniqueProductVariants(this.item.product_family, this.item.variants);
    },

    thc() {
      return Helpers.getTHCValue(this.item);
    },
    cbd() {
      return Helpers.getCBDValue(this.item);
    },

    // variantItemPrice() {
    //   if(_.isEmpty(this.selectedVariant)) {
    //     return this.firstItemPrice; // first item price
    //   } 
    //   if(this.selectedVariant.sale_price && (this.selectedVariant.sale_price < this.selectedVariant.price)){
    //     return this.selectedVariant.sale_price.toFixed(2);
    //   }
    //   return this.selectedVariant.price.toFixed(2);
    // },

    // firstItemPrice() {
    //   // Check first variant to figure out the price and sale 
    //   if(this.variants[0] && this.variants[0].price){
    //     if(this.variants[0].sale_price && this.variants[0].sale_price < this.variants[0].price){
    //       this.itemOnSale = true;
    //       let salePercentData = ((this.variants[0].price-this.variants[0].sale_price) / this.variants[0].price)*100;
    //       this.itemOnSalePercentage = ((salePercentData - Math.floor(salePercentData)) ? salePercentData.toFixed(0) : salePercentData) + '% OFF';
    //       return (this.variants[0].sale_price).toFixed(2);
    //     }
    //     this.itemOnSale = false;
    //     return (this.variants[0].price).toFixed(2);
    //   } 
    //   this.itemOnSale = false;
    //   return 0;
    // },

  },

  async mounted() {
    this.va_spinner(false);
    // this.totalNumberOfAddableVariants = await Helpers.getTotalNumberOfAddableVariants(this.variants);
    // if(this.totalNumberOfAddableVariants == 1){
    //   // if the available variant is only 1 make it auto selected
    //   this.selectedVariant =  Helpers.getFirstAvailableVariant(this.item.variants);
    // }

    // if(this.item.variants.length == 1){
    //   this.selectedVariant =  this.variants[0];
    // }

  },

  destroyed() {
   
  },

  methods: {

    /**
     * Add to cart
     */
    async addToCart(variant) {

      this.selectedVariant =  variant;
      // Fetch the product detail because the list api doesnot have full data
      this.va_spinner(true);
      let res = await ProductApis.fetchById(this.item.id);
      if(res.status != 200){
      return this.va_snackbar({
        type: 'warning', 
        message: 'Sorry error getting product detail.',
      });
      }
      this.productDetail = res.data.payload;

       // If we dont have cart id create cart first 
      if(this.vg_cartId == ''){
        await CartApis.createCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
      }
     
       // Check if variant is selected 
      if( _.isEmpty(this.selectedVariant) ) {
        this.va_spinner(false);
        return this.va_snackbar({
          type: 'warning', 
          message: 'Please Select Weight & Price.',
        });
      }

      // If already exceed limit
      if(parseFloat(this.vg_weightOnCart) > parseFloat(this.vg_cannabisLimit) ){
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: this.vg_weightOnCart,
          modal: true,
        });
        return false;
      }

      // If going to exceed limit on adding this item, no qty now this.qty *
      let currentProductWeight =  parseFloat(this.selectedVariant.weight_equivalent_dry_cannabis);
      let finalWeight = parseFloat(currentProductWeight) + parseFloat(this.vg_weightOnCart);

      if(finalWeight > parseFloat(this.vg_cannabisLimit) ) {
        this.va_spinner(false);
        bus.$emit('show-modal-cart-limit-exceed', {
          overWeight: finalWeight,
          modal: true,
        });
        return false;
      }

      let checkExistingProduct = _.find(this.vg_cartItems, { location_product_id: parseInt(this.productDetail.id), location_product_variant_id: parseInt(this.selectedVariant.id) });
 
      if(checkExistingProduct == undefined){
        // validate if we have instock
        if(parseInt(this.qty) > parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) ){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        let addedProduct =  await this.addCartItem();
        
        if(addedProduct){
          let recommendProductsRes = await ProductApis.fetchRecommendProductsByLocationProductIds({
            location_products_ids: this.vg_cartItemsIds
          }) 
          if(recommendProductsRes.status == 200){
            let collectrecommendProducts = Helpers.collectRecommendProducts(recommendProductsRes.data.payload);
            if(collectrecommendProducts.length > 0){
              bus.$emit('added-to-cart-recommend-products', {
                modal: true,
                addedProduct: addedProduct,
                recommendProducts: collectrecommendProducts
              })
            }
          }
        }

        this.va_spinner(false);
   
      } else {
        // Now before update lets check no of qty he can add
        let existingProductQty = checkExistingProduct.unit;
        // let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units) - parseInt(existingProductQty);
        let maxCanBeAdded = parseInt(this.selectedVariant.no_of_units - this.selectedVariant.inventory_threshold) - parseInt(existingProductQty);
        if(parseInt(this.qty) > maxCanBeAdded){
          // reject cannot add qty more than no of units
          this.va_spinner(false);
          return this.va_snackbar({
            message: Env.errorMessages.exceed_stock_limit,
            type: 'error',
          });
        } 
        await this.updateCartItem(checkExistingProduct);

      }
    },

    /**
     * Add cart item
     */
    async addCartItem() {
      let obj = {
        user_id: this.$store.getters.getLoggedInUserId,
        location_id: this.vg_selectedStore.id,
        cart_id: this.vg_cartId == '' ? 'Not available' : this.vg_cartId,
        location_product_id: this.productDetail.id,
        category_id: this.productDetail.category_id ? this.productDetail.category_id : null,
        category_name: this.productDetail.category ? this.productDetail.category.name : null,
        thc_cbd_value_type: this.productDetail.category ? this.productDetail.category.thc_cbd_value_type : '',
        product_name: this.productDetail.name,
        product_family: this.productDetail.product_family,
        product_id: this.productDetail.id,
        product_image: this.productDetail.image ? this.productDetail.image : 'http://unohop.dev.unoapp.io/img/leaf.47bfc5db.png',
        product_type: this.productDetail.product_type ? this.productDetail.product_type : '',
        brand_name: this.productDetail.brand ? this.productDetail.brand.name : '',
        location_product_variant_id: this.selectedVariant.id,
        location_variant_sku: this.selectedVariant.sku,
        location_product_variant_external_sku: this.selectedVariant.external_id,
        price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price, // if has sale price & sale must be lower than regular, then use sale else regular price
        actual_price: this.selectedVariant.price,
        weight: this.selectedVariant.weight_equivalent_dry_cannabis ? this.selectedVariant.weight_equivalent_dry_cannabis : 0,
        unit: 1,
        app_version: Env.appVersion,
        platform: Env.appPlatform,
        //product: this.productDetail, // triple to match fav style
        selected_variant: this.selectedVariant,        
        weighing_unit: this.productDetail.weighing_unit ? this.productDetail.weighing_unit : 'null',
      }

      // Add THC,CBD,cannabis attributes only if family is cannabis
      if(this.productDetail.product_family == 'cannabis'){
        obj.cannabis_attributes = this.productDetail.cannabis_attributes ? Helpers.unsetKeyFromObj(['createdAt', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.cannabis_attributes) : {};
        obj.thc_cbd_levels = this.productDetail.thc_cbd_levels ? Helpers.unsetKeyFromObj(['created_by', 'createdAt', 'updated_by', 'updatedAt', 'created_at', 'updated_at'], this.productDetail.thc_cbd_levels) : {};
      }

      let res = await CartApis.add(obj, this);
      if(res.status == 200) {
       
        // we get cart id here assign it
        this.va_setCartId(res.data.payload.id);
        this.va_setCartDetail(res.data.payload);
        if(this.$store.getters.getLoggedInUserId){
          // Description is not allowed on add to cart so add once its done for vbout
          //  obj.description = this.productDetail.description; not any more
          // lets save the data on vbout
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
       
        // G tracking add to cart
        this.$gtag.event('add_to_cart', { 
          items: [
            {
              id: this.productDetail.id,
              name: this.productDetail.name, 
              brand: this.productDetail.brand ? this.productDetail.brand.name : null,
              category: this.productDetail.category ? this.productDetail.category.name : null,
              variant: this.selectedVariant.size ? this.selectedVariant.size : null,
              quantity: parseInt(this.qty),
              price: parseFloat(this.selectedVariant.sale_price) > 0 && parseFloat(this.selectedVariant.sale_price) < parseFloat(this.selectedVariant.price) ? this.selectedVariant.sale_price : this.selectedVariant.price,
            }
          ]
        });
        if(!this.$store.getters.getLoggedInUserId){
          // If guest user else pubnub will throw
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        }
        return obj;
      } else {
        this.va_snackbar({
          message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
          type: res.status == 200 ? 'success' : 'error',
        });
        return false;
      }
 
    },

     /**
     * Update cart item
     */
    async updateCartItem(item) {
      this.va_spinner(true);
      //Clone the object and filter
      var obj = _.clone(item);
      obj.cart_item_id = item.id;
      obj.unit = parseInt(item.unit) + parseInt(1);
      obj.app_version = Env.appVersion;
      obj.platform = Env.appPlatform;
      let res = await CartApis.update(obj);
      this.va_spinner(false);
      if(res.status == 200) {
        if(this.$store.getters.getLoggedInUserId == false){
          // If guest user 
          this.va_snackbar({
            message: res.data.msg,
            type: 'success',
          });
        } else {
         // For vbout only push current added because its add api not update api
          obj.unit = parseInt(this.qty);
          VboutApis.addCartItem(obj, Helpers.getLocationProductFullUrl(this, obj.product_id), this.vg_selectedStore.id);
        }
        return true;
      } 
      this.va_snackbar({
        message: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        type: res.response.status == 200 ? 'success' : 'error',
      });
      return false;
    },
    /**
     * Return item regular or sale price
     */
    variantPrice(variant) {
      if(variant.sale_price && (variant.sale_price < variant.price)){
        return variant.sale_price.toFixed(2);
      }
      return variant.price.toFixed(2);
    },
    /**
     * Return is item on sale
     */
    isOnSale(variant) {
      if(variant.sale_price && (variant.sale_price < variant.price)){
        return true
      }
      return false;
    },
    /**
     * Return the item sale percentage
     */
    saleItemPercentage(variant) {
      let sale = ((variant.price-variant.sale_price) / variant.price)*100;
      return ((sale - Math.floor(sale)) ? sale.toFixed(0) : sale) + '% OFF';
    },
    /**
     * Get first 60 letters from var
     */
    getSixtyCharacters(str) {
      return str ? str.substring(0, 60) + (str.length > 60 ? '...' : '') : '';
    },
    /**
     * Generate aromas data
     */
    aromasData(aromas) {
      let icons = '';
      let plusCounts = 0;
      let aromasCount = aromas.length
      for (let i = 0; i < aromasCount; i++){
        if(i <= 2 ){
          icons += `<li class="is-flex"><span class="aroma-border">${this.aromasIcon[aromas[i].name] ? this.aromasIcon[aromas[i].name] : this.aromasIcon['Skunky']}</span> </li>`;
        } else {
          plusCounts++;
        }
      }
      return plusCounts > 0 ? icons + `<li class="is-flex"><span class="aromas-plus-count border-primary has-text-weight-semibold is-size-12 text-primary">+${plusCounts}</span></li>` : icons;
    },
    /**
     * Get three Chars from string
     */
    getThreeChars(str) {
      if(str.length > 4){
        return str.substring(0, 3) + '.';
      }
      return str;
    },
    ...mapActions({
      va_setCartId: "cart/setId",
      va_setCartDetail: "cart/setCartDetail",
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
    })

  }
};
</script>
